import { StatusTypeEnum } from '@features/regional-overview/digital-traps/components/status-tag/status-tag.model';
import type { NetworkMetric } from './network-management.models';

export const NETWORK_METRICS: NetworkMetric[] = [
  {
    key: 'battery',
    labelKey: 'pages.regional_overview.digital_traps.battery',
    statusType: StatusTypeEnum.BATTERY,
    positiveStatus: true
  },
  {
    key: 'signal',
    labelKey: 'pages.regional_overview.digital_traps.signal',
    statusType: StatusTypeEnum.SIGNAL
  },
  {
    key: 'pheromone',
    labelKey: 'pages.regional_overview.digital_traps.pheromone',
    statusType: StatusTypeEnum.PHEROMONE
  },
  {
    key: 'tweaks',
    labelKey: 'pages.regional_overview.digital_traps.tweaks',
    statusType: StatusTypeEnum.TWEAKS
  },
  {
    key: 'selfCleaning',
    labelKey: 'pages.regional_overview.digital_traps.self_cleaning',
    statusType: StatusTypeEnum.SELF_CLEANING
  }
];
